// import { AppConfig, LoadableAppConfig } from "./store";
// import { Action } from "redux";
// import { fetchConfig } from "@trp-ta-nitro/auth-react";
// import { ThunkAction } from "../actions";
//
// export const CONFIG_LOAD_ERROR = "APP_CONFIG_LOAD_ERROR";
// export const CONFIG_LOADED = "APP_CONFIG_LOADED";
//
// interface CONFIG_LOAD_ERROR extends Action<string> {
//     type: typeof CONFIG_LOAD_ERROR;
//     payload: Error;
// }
//
// interface CONFIG_LOADED_ACTION extends Action<string> {
//     type: typeof CONFIG_LOADED;
//     payload: AppConfig;
// }
//
// export type AppConfigAction = CONFIG_LOAD_ERROR | CONFIG_LOADED_ACTION;
//
// function configLoaded(appConfig: LoadableAppConfig): AppConfigAction {
//     return {
//         type: CONFIG_LOADED,
//         payload: appConfig
//     };
// }
//
// function configLoadError(err: Error): AppConfigAction {
//     return {
//         type: CONFIG_LOAD_ERROR,
//         payload: err
//     };
// }
//
// // Thunk Actions
// // =============
//
// export function loadConfig(): ThunkAction<AppConfigAction> {
//     return (dispatch) => {
//         fetchConfig<AppConfig>(["baseConfig.json", "envConfig.json"])
//             .then((appConfig) => {
//                 dispatch(configLoaded(appConfig));
//             })
//             .catch((err) => dispatch(configLoadError(err)));
//     };
// }

export const LOAD_CONFIG = 'LOAD_CONFIG';

export const loadConfig = (appConfig: string) => ({
    type: LOAD_CONFIG,
    payload: appConfig,
});
